import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import StarryBackground from './StarryBackground';
import App from './App';
import { UserProvider } from './UserContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <UserProvider>
            <StarryBackground />
            <App />
        </UserProvider>
    </React.StrictMode>
);
